module.exports = __webpack_public_path__ + "static/header2-95825d3a4598076f3b8db64a96e6bc8d.jpg";